import { ClientBrandCode } from '@domgen/dgx-fe-common';
import { ApplianceDetailsSteppedFormConfig } from '../../models/appliance-details-stepped/appliance-details-stepped-form-config.interface';
import { mockApplianceDetailsSteppedFormValue } from './appliance-details-stepped-form-value.mock';
import { mockCmsApplianceDetailsSteppedForm } from './cms-appliance-details-stepped-form.mock';

export const mockApplianceDetailsSteppedFormConfig: ApplianceDetailsSteppedFormConfig =
  {
    applianceMaximumAge: new Date(),
    clientBrandCode: ClientBrandCode.Beko,
    cmsData: mockCmsApplianceDetailsSteppedForm,
    initialValue: mockApplianceDetailsSteppedFormValue,
  };
